import { Injectable } from '@angular/core';
import { AppConfiguration } from '../models/app-configuration';
import { firstValueFrom, from } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppConfigurationService {
  public configuration: Partial<AppConfiguration> = {};

  public init() {
    return firstValueFrom(
      from(
        (async () => {
          const response = await fetch('assets/app-config.json');
          if (!response.ok) {
            throw new Error('Unable to load config file');
          }

          const config = await response.json();
          this.configuration = config;

          const additionalConfigFileName = environment.additionalConfigFileName;
          if (additionalConfigFileName) {
            const response = await fetch(`assets/${additionalConfigFileName}`);
            if (!response.ok) {
              throw new Error('Unable to load additional config file.');
            }

            const localConfig = await response.json();
            this.configuration = {
              ...this.configuration,
              ...localConfig
            };
          }
        })()
      )
    );
  }
}
